import "./scss/landingPage.scss";
import "./scss/category.scss";
import "./scss/content.scss";
import "./scss/popup.scss";
import "./scss/casestudypopup.scss";
import "./scss/loading.scss";
import "./scss/videopage.scss";
import "./scss/login.scss";
import Model from "./Model/model.js";
import contentView from "./View/contentView.js";
import categoryView from "./View/categoryView.js";
import landingView from "./View/landingView.js";
import { preloadAllMedia } from "./preload.js";
import API from "./api.js";
import Auth from "./auth.js";
import Tracker from "./tracker.js";

import gsap from "gsap";
import videopage from "./View/videopage.js";
let currentBackground = "";

const init = () => {
  // currentBackground = Model.bgvideo.landing;
  landingView.addvideo(Model.bgvideo.landing);
  landingView.clickHandler(() => {
    landingView.hide();
    categoryView.show();
  });
  categoryView.clickhandler((id) => {
    categoryView.hide();
    contentView.renderSection(Model.getSectionById(id));
    updateBackground("content", id);
  });

  contentView.renderbackclick(() => {
    contentView.hide();
    updateBackground("landing");
    // categoryView.show();
  });
  landingView.brandLogoHandler(() => {
    showLandingPage();
    updateBackground("landing");
  });

  contentView.handleCardClick((cardId) => {
    const cardData = Model.getCardData(cardId);
    // console.log(cardData);
    contentView.renderCardPopup(cardData);
  });

  contentView.handleTagClick((cardId, tagIndex) => {
    const cardData = Model.getCardData(cardId);
    // console.log(cardData);
    contentView.renderTagPopup(cardData, tagIndex);
  });

  contentView.renderclosepopup((handler) => {
    // updateBackground("landing");
  });

  landingView.landingbottomclickhandler((id) => {
    const selectedVideo = Model.landingvideo.find((vidObj) => vidObj.id === id);
    videopage.playvideo(selectedVideo.video);
    landingView.hide();
  });

  videopage.hidevideopage((handler) => {
    landingView.show();
  });
};

function showLandingPage() {
  // Fade out all other sections
  landingView.landingarrowisclick = false;
  contentView.backisclick = false;
  contentView.rendersectionisclick = false;
  const sections = [categoryView, contentView];

  sections.forEach((view) => {
    if (!view?.section) return;

    // Just fade out opacity, no display change
    gsap.to(view.section, {
      opacity: 0,
      duration: 0.6,
      ease: "power1.inOut",
    });
  });

  // Bring landing page into view
  gsap.set(landingView.section, { display: "flex", opacity: 0, y: 0 });
  gsap.to(landingView.section, {
    opacity: 1,
    duration: 0.8,
    ease: "power2.out",
  });
}

(async function bootstrap() {
  const form = document.getElementById("loginForm");
  const errorDiv = document.getElementById("errorMessage");
  const submitBtn = document.getElementById("loginBtn");
  const btnText = submitBtn.querySelector(".btn-text");
  const btnLoader = submitBtn.querySelector(".btn-loader");
  const loginBox = document.querySelector(".auth-container");

  function showError(message) {
    errorDiv.textContent = message;
    errorDiv.style.display = "block";
    errorDiv.classList.add("shake");
    setTimeout(() => errorDiv.classList.remove("shake"), 500);
  }

  function setLoading(loading) {
    submitBtn.disabled = loading;
    btnText.style.display = loading ? "none" : "inline";
    btnLoader.style.display = loading ? "inline-flex" : "none";
  }

  // If already logged in, redirect to home
  if (Auth.isLoggedIn()) {
    loginBox.classList.add("fade-out");
    loadApp();
    return;
  }

  form.addEventListener("submit", async (e) => {
    e.preventDefault();
    errorDiv.style.display = "none";

    const username = document.getElementById("username").value.trim();
    const password = document.getElementById("password").value;

    if (!username || !password) {
      showError("Please fill in all fields");
      return;
    }

    setLoading(true);

    try {
      const data = await API.post("login.php", { username, password });

      if (data && data.success) {
        Auth.login(data.token, data.user);

        // Smooth transition
        loginBox.classList.add("fade-out");
        setTimeout(() => {
          loadApp();
        }, 400);
      }
    } catch (error) {
      showError(error.message || "Login failed. Please try again.");
    } finally {
      setLoading(false);
    }
  });

  async function loadApp() {
    // Fetch and inject app.html into the empty shell
    const res = await fetch("app.html");
    const html = await res.text();
    document.getElementById("main_section").innerHTML = html;

    // NOW initialise views — DOM elements exist
    landingView.init();
    categoryView.init();
    contentView.init();
    videopage.init();
    Tracker.init();

    // Run your existing app logic
    Model.loadAssets(() => {
      init();
    });
  }
})();

function updateBackground(level, id) {
  let newSrc = "";

  if (level === "landing") {
    newSrc = Model.bgvideo.landing;
  } else if (level === "content") {
    const section = Model.getSectionById(id);
    newSrc = section?.bgvideo;
  }

  if (newSrc && newSrc !== currentBackground) {
    crossfadeBackground(newSrc);
    currentBackground = newSrc;
  }
  // const current = document.querySelector(`#bgVideo1`);
  // current.src = newSrc;
  // current.load();
  // current.play().catch(() => {});
}

let activeIndex = 1;

function crossfadeBackground(newSrc) {
  // console.log(activeIndex);
  const current = document.querySelector(`#bgVideo${activeIndex}`);
  const next = document.querySelector(`#bgVideo${activeIndex === 1 ? 2 : 1}`);

  if (!next || !current) return;

  // If same video already playing, skip
  if (current.src.endsWith(newSrc)) return;

  next.src = newSrc;
  next.load();

  const activateNext = () => {
    next.classList.add("active");
    current.classList.remove("active");
    next.play().catch(() => {});
    setTimeout(() => current.pause(), 800);
  };

  // If video already ready, play instantly
  // if (next.readyState >= 3) {
  activateNext();
  // } else {
  //   next.oncanplay = activateNext;
  // }

  activeIndex = activeIndex === 1 ? 2 : 1;
}
